<div class="grid grid-cols-2 fullhd:grid-cols-2 gap-4">
  <section class="bm-card bm-card-sm bm-card-border border-base-300">
    <div class="bm-card-body mt-2">
      <h3 class="bm-card-title bm-card-title-top px-1 bg-base-100">
        Beauftragung
        <button
          class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost opacity-25 hover:opacity-100"
          (click)="editDescription = !editDescription"
        >
          @if (editDescription) {
            <fa-icon [icon]="['far', 'times']" />
          } @else {
            <fa-icon [icon]="['far', 'edit']" />
          }
        </button>
      </h3>
      @if (editDescription) {
        <hawk-shared-edit-input
          [textValue]="operation.description"
          [modus]="'textarea'"
          (saveClicked)="saveDescription($event)"
          (cancelClicked)="editDescription = false"
        />
      } @else {
        <p class="description" [innerHtml]="convertLinebreaks(operation.description, true)"></p>
      }
    </div>
  </section>

  @if (!ticket.is_mt) {
  <section class="bm-card bm-card-sm bm-card-border border-base-300">
    <div class="bm-card-body mt-2">
      <h3 class="bm-card-title bm-card-title-top px-1 bg-base-100">
        Ai Zusammenfassung
        <button
          class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost opacity-25 hover:opacity-100"
          (click)="editDescriptionAi = !editDescriptionAi"
        >
          @if (editDescriptionAi) {
            <fa-icon [icon]="['far', 'times']" />
          } @else {
            <fa-icon [icon]="['far', 'edit']" />
          }
        </button>
      </h3>
      @if (editDescriptionAi) {
        <hawk-shared-edit-input
          [textValue]="operation.description_ai"
          [modus]="'textarea'"
          (saveClicked)="saveDescriptionAi($event)"
          (cancelClicked)="editDescriptionAi = false"
        />
      } @else {
        <p class="description_ai" [innerHtml]="convertLinebreaks(operation.description_ai, true)"></p>
        <dl class="bm-dl gap-x-4 align-items-center">
          <dt (click)="editItemCount = !editItemCount">
            <span>Anzahl Stationen/Waagen</span>
            <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
              <fa-icon [icon]="['far', 'edit']" />
            </button>
          </dt>
          @if (!editItemCount) {
            <dd>{{ operation?.item_count || "-" }}</dd>
          } @else {
            <hawk-shared-edit-input
              class="col-span-2"
              [numberValue]="operation.item_count"
              [modus]="'number'"
              (saveClicked)="saveItemCount($event)"
              (cancelClicked)="editItemCount = false"
            />
          }
          <dt (click)="editAiCorrect = !editAiCorrect">
            <span>Ai Berechnung korrekt?</span>
            <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
              <fa-icon [icon]="['far', 'edit']" />
            </button>
          </dt>

          @if (!editAiCorrect) {
            @if (operation.ai_calculation_correct) {
              <dd><fa-icon [icon]="['far', 'check']" /></dd>
            }
          } @else {
            <hawk-shared-edit-input
              [boolValue]="operation.ai_calculation_correct"
              [modus]="'checkbox'"
              (saveClicked)="saveOperationAiCorrect($event)"
              (cancelClicked)="editAiCorrect = false"
            />
          }
        </dl>
      }
    </div>
  </section>
  }
</div>

<div class="operationSubpage">
  <section class="mt-3">
    <div class="bm-tabs bm-tabs-box" role="tablist">
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('overview')"
        (click)="selectedTab = 'overview'"
      >
        Rückmeldung
      </button>
      @if (checklist) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('checklist')"
          (click)="selectedTab = 'checklist'"
        >
          Checkliste
        </button>
      }
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('operation_data')"
        (click)="selectedTab = 'operation_data'"
      >
        Einsatzdaten
      </button>
      <button role="tab" class="bm-tab" [class.bm-tab-active]="isTabSelected('steps')" (click)="selectedTab = 'steps'">
        Schritte
      </button>
      @if (ticket.is_mt) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('mt_result')"
          (click)="selectedTab = 'mt_result'"
        >
          MT Ergebnis
        </button>
      }
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('material')"
        (click)="selectedTab = 'material'"
      >
        Material
      </button>
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('requirements')"
        (click)="selectedTab = 'requirements'"
      >
        Artikelbedarf
      </button>
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('delivery_notes')"
        (click)="selectedTab = 'delivery_notes'"
      >
        Lieferscheine
      </button>
      @if (isBookkeeper) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('billing')"
          (click)="selectedTab = 'billing'"
        >
          Abrechnung
        </button>
      }
      <button role="tab" class="bm-tab" [class.bm-tab-active]="isTabSelected('files')" (click)="selectedTab = 'files'">
        Dateien
      </button>
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('extras')"
        (click)="selectedTab = 'extras'"
      >
        Extras
      </button>
      @if (ticket.is_mt) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('mt_bonus')"
          (click)="selectedTab = 'mt_bonus'"
        >
          MT Spezial
        </button>
      }
      @if (ticket.is_mt) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('mt_devices')"
          (click)="selectedTab = 'mt_devices'"
        >
          MT Geräte
        </button>
      }

      <div class="bm-tab-content bg-base-100 border-base-100 p-3">
        @if (selectedTab === "overview") {
          <div class="grid grid-cols-[auto_1fr] gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">Details</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt>ID</dt>
                <dd>{{ operation?.id }}</dd>

                <dt (click)="editOperationDate = !editOperationDate">
                  <span>Plandatum</span>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editOperationDate) {
                  <dd>{{ operation.operation_date | date: "dd.MM.yyyy HH:mm" }}</dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [textValue]="operation.operation_date"
                    [modus]="'date'"
                    (saveClicked)="saveOperationDate($event)"
                    (cancelClicked)="editOperationDate = false"
                  />
                }

                <dt (click)="editDateFixed = !editDateFixed">
                  <span>Fixtermin?</span>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editDateFixed) {
                  <dd>
                    @if (operation.date_fixed) {
                      <fa-icon [icon]="['far', 'check']" />
                    } @else {
                      <span>nein</span>
                    }
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [boolValue]="operation.date_fixed"
                    [modus]="'checkbox'"
                    (saveClicked)="saveDateFixed($event)"
                    (cancelClicked)="editDateFixed = false"
                  />
                }

                <dt
                  [class.self-start]="editTechnicians"
                  (click)="editTechnicians ? (editTechnicians = false) : openTechnicianForm()"
                >
                  Techniker
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editTechnicians) {
                  <dd>
                    @for (tech of operation.technicians; track $index) {
                      <a routerLink="/benutzer/{{ tech.id }}" target="_blank" class="bm-link bm-link-hover">
                        {{ tech.full_name }}
                      </a>
                      @if (tech.phone1) {
                        (<a href="tel:{{ tech.phone1 }}" class="bm-link bm-link-hover">{{ tech.phone1 }}</a
                        >)
                      }
                    }
                  </dd>
                } @else {
                  <dd class="col-span-2">
                    <div class="flex flex-row items-center gap-1">
                      <b class="w-full">bisher ausgewählt</b>
                      <div class="bm-join">
                        <button class="bm-join-item bm-btn bm-btn-sm bm-btn-primary" (click)="saveTechnicians()">
                          <fa-icon [icon]="['far', 'save']" />
                        </button>
                        <button
                          class="bm-join-item bm-btn bm-btn-sm bm-btn-square bm-btn-ghost"
                          (click)="editTechnicians = false"
                        >
                          <fa-icon [icon]="['far', 'times']" />
                        </button>
                      </div>
                    </div>
                    @for (technician of selectedTechnicians(); track $index) {
                      <div class="flex flex-row gap-1 items-center">
                        <span>
                          {{ technician.name }}
                        </span>
                        @if (technician.company) {
                          <small>({{ technician.company }})</small>
                        }
                        <button
                          class="bm-join-item bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-bm-btn-ghost"
                          (click)="removeTechnician(technician.id)"
                        >
                          <fa-icon [icon]="['fas', 'trash']" />
                        </button>
                      </div>
                    }
                    <input
                      type="text"
                      class="bm-input w-full"
                      placeholder="Technikername suchen"
                      [(ngModel)]="techicianSearchboxValue"
                    />
                    @for (
                      technician of technicians | technicianFilter: techicianSearchboxValue | slice: 0 : 5;
                      track $index
                    ) {
                      <div class="flex flex-row gap-1 items-center">
                        <span>
                          {{ technician.name }}
                        </span>
                        @if (technician.company) {
                          <small>({{ technician.company }})</small>
                        }
                        <button
                          class="bm-join-item bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-bm-btn-ghost"
                          (click)="addTechnician(technician.id)"
                        >
                          <fa-icon [icon]="['fas', 'user-plus']" />
                        </button>
                      </div>
                    }
                  </dd>
                }

                <div class="bm-divider my-0 col-span-3"></div>

                <dt (click)="editStatus = !editStatus">
                  Status
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editStatus) {
                  <dd>{{ status() }}</dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [textValue]="operation.status"
                    [selectOptions]="statusOptions"
                    [modus]="'select'"
                    (saveClicked)="saveStatus($event)"
                    (cancelClicked)="editStatus = false"
                  />
                }
                @if (operation.metadata) {
                  <dt (click)="toggleStepStatus()">
                    Schrittstatus
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  @if (!editStepstatus) {
                    <dd>{{ stepStatus() }}</dd>
                  } @else {
                    <dd>
                      <button class="bm-btn" (click)="markStepDone()">Schritte abschließen!</button><br />
                      <small>{{ stepWarning }}</small>
                    </dd>
                    <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="toggleStepStatus()">
                      <fa-icon [icon]="['far', 'times']" />
                    </button>
                  }
                }

                <div class="bm-divider my-0 col-span-3 row-"></div>

                <!-- Pauschale Abrechnung (#550): Zeitstempel als dt/dd (bündig mit den -->
                <!-- übrigen Detailfeldern); im dd je eine Ist- und Pauschal-Spalte. -->
                <dt></dt>
                <dd>
                  @if (ticket.flatrate_billing) {
                    <div class="grid grid-cols-[8rem_auto] items-center gap-3">
                      <span class="text-xs font-semibold text-base-content/60">Technikerzeiten</span>
                      <label class="bm-label cursor-pointer justify-start gap-2 py-0">
                        <input type="checkbox" class="bm-toggle bm-toggle-sm" [(ngModel)]="ticket.flatrate_billing" (ngModelChange)="saveFlatrateBilling($event)" />
                        <span class="text-xs font-semibold">Pauschale Abrechnung</span>
                      </label>
                    </div>
                  } @else {
                    <label class="bm-label cursor-pointer justify-start gap-2 py-0">
                      <input type="checkbox" class="bm-toggle bm-toggle-sm" [(ngModel)]="ticket.flatrate_billing" (ngModelChange)="saveFlatrateBilling($event)" />
                      <span class="text-xs font-semibold">Pauschale Abrechnung</span>
                    </label>
                  }
                </dd>

                <dt (click)="editTravelStart = !editTravelStart">
                  Reisebeginn
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost"><fa-icon [icon]="['far', 'edit']" /></button>
                </dt>
                @if (!editTravelStart) {
                  <dd>
                    <div [class]="ticket.flatrate_billing ? 'grid grid-cols-[8rem_auto] items-center gap-3' : ''">
                      <span [class]="ticket.flatrate_billing ? 'text-base-content/70' : ''">{{ operation.date_travel_start | date: "dd.MM.yyyy HH:mm" }}</span>
                      @if (ticket.flatrate_billing) {
                        <span class="flex items-center gap-1">
                          @if (!editFlatrateTravelStart) {
                            <span class="font-bold">{{ operation.flatrate_travel_start | date: "dd.MM.yyyy HH:mm" }}</span>
                            <button type="button" class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="editFlatrateTravelStart = true"><fa-icon [icon]="['far', 'edit']" /></button>
                          } @else {
                            <hawk-shared-edit-input [dateValue]="operation.flatrate_travel_start" [modus]="'date'" (saveClicked)="saveFlatrateTravelStart($event); editFlatrateTravelStart = false" (cancelClicked)="editFlatrateTravelStart = false" />
                          }
                        </span>
                      }
                    </div>
                  </dd>
                } @else {
                  <hawk-shared-edit-input class="col-span-2" [dateValue]="operation.date_travel_start" [modus]="'date'" (saveClicked)="saveTravelStart($event); editTravelStart = false" (cancelClicked)="editTravelStart = false" />
                }

                <dt (click)="editArrival = !editArrival">
                  Ankunft
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost"><fa-icon [icon]="['far', 'edit']" /></button>
                </dt>
                @if (!editArrival) {
                  <dd>
                    <div [class]="ticket.flatrate_billing ? 'grid grid-cols-[8rem_auto] items-center gap-3' : ''">
                      <span [class]="ticket.flatrate_billing ? 'text-base-content/70' : ''">{{ operation.date_on_site | date: "dd.MM.yyyy HH:mm" }}</span>
                      @if (ticket.flatrate_billing) {
                        <span class="flex items-center gap-1">
                          @if (!editFlatrateOnSite) {
                            <span class="font-bold">{{ operation.flatrate_on_site | date: "dd.MM.yyyy HH:mm" }}</span>
                            <button type="button" class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="editFlatrateOnSite = true"><fa-icon [icon]="['far', 'edit']" /></button>
                          } @else {
                            <hawk-shared-edit-input [dateValue]="operation.flatrate_on_site" [modus]="'date'" (saveClicked)="saveFlatrateOnSite($event); editFlatrateOnSite = false" (cancelClicked)="editFlatrateOnSite = false" />
                          }
                        </span>
                      }
                    </div>
                  </dd>
                } @else {
                  <hawk-shared-edit-input class="col-span-2" [dateValue]="operation.date_on_site" [modus]="'date'" (saveClicked)="saveArrival($event); editArrival = false" (cancelClicked)="editArrival = false" />
                }

                <dt (click)="editRepaired = !editRepaired">
                  Wiederhergestellt
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost"><fa-icon [icon]="['far', 'edit']" /></button>
                </dt>
                @if (!editRepaired) {
                  <dd>
                    <div [class]="ticket.flatrate_billing ? 'grid grid-cols-[8rem_auto] items-center gap-3' : ''">
                      <span [class]="ticket.flatrate_billing ? 'text-base-content/70' : ''">{{ operation.date_repaired | date: "dd.MM.yyyy HH:mm" }}</span>
                      @if (ticket.flatrate_billing) {
                        <span class="flex items-center gap-1">
                          @if (!editFlatrateRepaired) {
                            <span class="font-bold">{{ operation.flatrate_repaired | date: "dd.MM.yyyy HH:mm" }}</span>
                            <button type="button" class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="editFlatrateRepaired = true"><fa-icon [icon]="['far', 'edit']" /></button>
                          } @else {
                            <hawk-shared-edit-input [dateValue]="operation.flatrate_repaired" [modus]="'date'" (saveClicked)="saveFlatrateRepaired($event); editFlatrateRepaired = false" (cancelClicked)="editFlatrateRepaired = false" />
                          }
                        </span>
                      }
                    </div>
                  </dd>
                } @else {
                  <hawk-shared-edit-input class="col-span-2" [dateValue]="operation.date_repaired" [modus]="'date'" (saveClicked)="saveRepaired($event); editRepaired = false" (cancelClicked)="editRepaired = false" />
                }

                <dt (click)="editFinished = !editFinished">
                  Abgeschlossen
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost"><fa-icon [icon]="['far', 'edit']" /></button>
                </dt>
                @if (!editFinished) {
                  <dd>
                    <div [class]="ticket.flatrate_billing ? 'grid grid-cols-[8rem_auto] items-center gap-3' : ''">
                      <span [class]="ticket.flatrate_billing ? 'text-base-content/70' : ''">{{ operation.date_finished | date: "dd.MM.yyyy HH:mm" }}</span>
                      @if (ticket.flatrate_billing) {
                        <span class="flex items-center gap-1">
                          @if (!editFlatrateFinished) {
                            <span class="font-bold">{{ operation.flatrate_finished | date: "dd.MM.yyyy HH:mm" }}</span>
                            <button type="button" class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="editFlatrateFinished = true"><fa-icon [icon]="['far', 'edit']" /></button>
                          } @else {
                            <hawk-shared-edit-input [dateValue]="operation.flatrate_finished" [modus]="'date'" (saveClicked)="saveFlatrateFinished($event); editFlatrateFinished = false" (cancelClicked)="editFlatrateFinished = false" />
                          }
                        </span>
                      }
                    </div>
                  </dd>
                } @else {
                  <hawk-shared-edit-input class="col-span-2" [dateValue]="operation.date_finished" [modus]="'date'" (saveClicked)="saveFinished($event); editFinished = false" (cancelClicked)="editFinished = false" />
                }

                <dt (click)="editDistance = !editDistance">
                  Entfernung
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editDistance) {
                  <dd>
                    @if (operation.distance && operation.distance > 0) {
                      <span>{{ operation.distance | number: "1.0-0" }} km</span>
                    } @else {
                      <span>—</span>
                    }
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [numberValue]="operation.distance"
                    [modus]="'number'"
                    (saveClicked)="saveDistance($event)"
                    (cancelClicked)="editDistance = false"
                  />
                }
                <dt>GPS Reisebeginn</dt>
                <dd>
                  @if (operation.geolocations?.date_travel_start; as geo) {
                    <span>{{ geo.latitude }}, {{ geo.longitude }}</span>
                    <a
                      class="bm-link bm-link-hover ml-2"
                      [href]="'https://www.google.com/maps?q=' + geo.latitude + ',' + geo.longitude"
                      target="_blank"
                    >
                      Auf Google Maps öffnen
                    </a>
                    @if (geo.count > 1) {
                      <span class="opacity-60 ml-2">(+{{ geo.count - 1 }} weitere)</span>
                    }
                  } @else {
                    <span>keine Koordinaten vorhanden</span>
                  }
                </dd>
              </dl>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">KPI</h3>
              <!-- KPI-Layout: links Lieferscheine + Dateien untereinander (schmal), -->
              <!-- rechts Material in doppelter Breite (mehr Platz für den Titel). -->
              <div class="grid grid-cols-3 gap-3 items-start">
                <!-- Linke Spalte: Lieferscheine + Dateien gestapelt -->
                <div class="flex flex-col gap-3 min-w-0">
                  <!-- Lieferscheine -->
                  <div class="flex flex-col gap-1 min-w-0">
                    <button
                      type="button"
                      class="h-auto rounded-lg border border-base-300 hover:border-primary p-2 flex flex-row items-center justify-center gap-2 cursor-pointer"
                      (click)="selectedTab = 'delivery_notes'"
                    >
                      <fa-icon [icon]="['far', 'truck']" class="text-sm opacity-70" />
                      <span class="text-sm font-bold leading-none">{{ ticket.delivery_notes?.length || 0 }}</span>
                      <span class="text-sm">Lieferscheine</span>
                    </button>
                    <div class="flex flex-col gap-0.5 text-xs max-h-32 overflow-y-auto">
                      @for (dn of ticket.delivery_notes; track dn) {
                        <div
                          class="flex flex-row items-center gap-1 px-1 py-0.5 rounded hover:bg-base-200 cursor-pointer"
                          (click)="selectedTab = 'delivery_notes'"
                        >
                          <fa-icon [icon]="['far', 'truck']" class="opacity-60" />
                          <span class="truncate flex-1 min-w-0">{{ dn.number }}</span>
                          <span class="opacity-70 whitespace-nowrap">
                            @switch (dn.note_type) {
                              @case ("incoming") { Entgegengenommen }
                              @case ("installed") { Eingebaut }
                              @case ("removed") { Ausgebaut }
                              @case ("returned") { Zurückgeschickt }
                            }
                          </span>
                        </div>
                      } @empty {
                        <span class="opacity-50 px-1">keine</span>
                      }
                    </div>
                  </div>
                  <!-- Dateien -->
                  <div class="flex flex-col gap-1 min-w-0">
                    <button
                      type="button"
                      class="h-auto rounded-lg border border-base-300 hover:border-primary p-2 flex flex-row items-center justify-center gap-2 cursor-pointer"
                      (click)="selectedTab = 'files'"
                    >
                      <fa-icon [icon]="['far', 'file']" class="text-sm opacity-70" />
                      <span class="text-sm font-bold leading-none">{{ (files?.length || 0) + 1 }}</span>
                      <span class="text-sm">Dateien</span>
                    </button>
                    <div class="flex flex-col gap-0.5 text-xs max-h-32 overflow-y-auto">
                      <!-- Servicebericht ist immer vorhanden und steht oben. -->
                      <a
                        [href]="reportPdfUrl()"
                        target="_blank"
                        class="flex flex-row items-center gap-1 px-1 py-0.5 rounded hover:bg-base-200 bm-link-hover"
                      >
                        <fa-icon [icon]="['far', 'file']" class="opacity-60" />
                        <span class="truncate flex-1 min-w-0">Servicebericht (pdf)</span>
                      </a>
                      @for (file of files; track $index) {
                        <a
                          href="{{ file.path }}"
                          target="_blank"
                          class="flex flex-row items-center gap-1 px-1 py-0.5 rounded hover:bg-base-200 bm-link-hover"
                        >
                          <fa-icon [icon]="['far', 'file']" class="opacity-60" />
                          <span class="truncate flex-1 min-w-0">{{ file.filename }}</span>
                        </a>
                      }
                    </div>
                  </div>
                  <!-- Abrechnung: nur fuer Buchhaltung. Werte nach Kundenlogik gruppiert -->
                  <!-- (An Kunden = unser Umsatz, Von Partner = Ist-Rechnung, -->
                  <!-- Erwartet = PO + POX + PO15 = was der Partner abrechnen darf). -->
                  @if (isBookkeeper) {
                    <div class="flex flex-col gap-1 min-w-0">
                      <button
                        type="button"
                        class="h-auto rounded-lg border border-base-300 hover:border-primary p-2 flex flex-row items-center justify-center gap-2 cursor-pointer"
                        (click)="selectedTab = 'billing'"
                      >
                        <fa-icon [icon]="['far', 'file-invoice-dollar']" class="text-sm opacity-70" />
                        <span class="text-sm font-bold leading-none">
                          @if (operation.invoice_amount) {
                            {{ operation.invoice_amount | number: "1.2-2" }} €
                          } @else {
                            –
                          }
                        </span>
                        <span class="text-sm">Abrechnung</span>
                      </button>
                      <div class="flex flex-col gap-2 text-xs">
                        <!-- An Kunden: unser Umsatz -->
                        <div class="flex flex-col gap-0.5 px-1">
                          <div class="flex flex-row items-center justify-between gap-2">
                            <span class="opacity-70">An Kunden</span>
                            <span class="font-semibold whitespace-nowrap" [class.text-green-600]="customerAmountOk">
                              @if (operation.invoice_amount) {
                                {{ operation.invoice_amount | number: "1.2-2" }} €
                              } @else {
                                –
                              }
                            </span>
                          </div>
                          @if (operation.invoice) {
                            <span class="opacity-50 font-mono truncate">{{ operation.invoice }}</span>
                          }
                        </div>
                        <!-- Von Partner: tatsaechliche Rechnung (Ist) -->
                        <div class="flex flex-col gap-0.5 px-1 border-t border-base-200 pt-1">
                          <div class="flex flex-row items-center justify-between gap-2">
                            <span class="opacity-70">Von Partner (Ist)</span>
                            <span class="font-semibold whitespace-nowrap" [class.text-green-600]="partnerAmountOk">
                              @if (operation.invoice_partner_amount) {
                                {{ operation.invoice_partner_amount | number: "1.2-2" }} €
                              } @else {
                                –
                              }
                            </span>
                          </div>
                          @if (operation.invoice_partner) {
                            <span class="opacity-50 font-mono truncate">{{ operation.invoice_partner }}</span>
                          }
                        </div>
                        <!-- Erwartet vom Partner (Soll): PO + POX + PO15 -->
                        <div class="flex flex-col gap-0.5 px-1 border-t border-base-200 pt-1">
                          <span class="opacity-70">Erwartet (PO)</span>
                          <div class="flex flex-row items-center justify-between gap-2 opacity-60">
                            <span>PO / Bestellung</span>
                            <span class="whitespace-nowrap">
                              @if (operation.invoice_po_order_amount) {
                                {{ operation.invoice_po_order_amount | number: "1.2-2" }} €
                              } @else {
                                –
                              }
                            </span>
                          </div>
                          <div class="flex flex-row items-center justify-between gap-2 opacity-60">
                            <span>POX (Sonder)</span>
                            <span class="whitespace-nowrap">
                              @if (operation.invoice_pox_order_amount) {
                                {{ operation.invoice_pox_order_amount | number: "1.2-2" }} €
                              } @else {
                                –
                              }
                            </span>
                          </div>
                          <div class="flex flex-row items-center justify-between gap-2 opacity-60">
                            <span>PO15 (Mehrzeit)</span>
                            <span class="whitespace-nowrap">
                              @if (operation.invoice_po15_order_amount) {
                                {{ operation.invoice_po15_order_amount | number: "1.2-2" }} €
                              } @else {
                                –
                              }
                            </span>
                          </div>
                          <!-- Summe der erwarteten Partner-Betraege (Soll) -->
                          <div class="flex flex-row items-center justify-between gap-2 border-t border-base-200 mt-0.5 pt-0.5">
                            <span class="opacity-70">Summe</span>
                            <span class="font-semibold whitespace-nowrap">{{ expectedPoTotal | number: "1.2-2" }} €</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <!-- Rechte Spalte (doppelte Breite): Material + Artikelbedarf gestapelt -->
                <div class="col-span-2 flex flex-col gap-3 min-w-0">
                  <!-- Material: Titel bricht um statt abgeschnitten zu werden -->
                  <div class="flex flex-col gap-1 min-w-0">
                    <button
                      type="button"
                      class="h-auto rounded-lg border border-base-300 hover:border-primary p-2 flex flex-row items-center justify-center gap-2 cursor-pointer"
                      (click)="selectedTab = 'material'"
                    >
                      <fa-icon [icon]="['far', 'box']" class="text-sm opacity-70" />
                      <span class="text-sm font-bold leading-none">{{ (ticket.material?.length || 0) + (parts?.length || 0) }}</span>
                      <span class="text-sm">Material</span>
                    </button>
                    <div class="flex flex-col gap-0.5 text-xs max-h-72 overflow-y-auto">
                      @for (material of ticket.material; track $index) {
                        <div
                          class="flex flex-row items-start gap-2 px-1 py-0.5 rounded hover:bg-base-200 cursor-pointer"
                          (click)="selectedTab = 'material'"
                        >
                          <fa-icon [icon]="['far', 'box']" class="opacity-60 mt-0.5" />
                          <span class="flex-1 min-w-0 break-words">{{ material.title }}</span>
                          <span class="opacity-70 whitespace-nowrap">{{ material.amount }}x</span>
                        </div>
                      }
                      @for (part of parts; track $index) {
                        <div
                          class="flex flex-row items-start gap-2 px-1 py-0.5 rounded hover:bg-base-200 cursor-pointer"
                          (click)="selectedTab = 'material'"
                        >
                          <fa-icon [icon]="['far', 'exchange']" class="opacity-60 mt-0.5" />
                          <span class="flex-1 min-w-0 break-words">{{ part.article?.description || part.rma }}</span>
                          <span class="opacity-70 whitespace-nowrap font-mono">{{ part.newsn || part.oldsn }}</span>
                        </div>
                      }
                      @if ((ticket.material?.length || 0) + (parts?.length || 0) === 0) {
                        <span class="opacity-50 px-1">keine</span>
                      }
                    </div>
                  </div>
                  <!-- Artikelbedarf: oben Anzahl Versand + Staging, darunter die beiden Listen -->
                  <div class="flex flex-col gap-1 min-w-0">
                    <button
                      type="button"
                      class="h-auto rounded-lg border border-base-300 hover:border-primary p-2 flex flex-row items-center justify-center gap-4 cursor-pointer"
                      (click)="selectedTab = 'requirements'"
                    >
                      <span class="text-sm">Artikelbedarf</span>
                      <span class="flex flex-row items-center gap-1">
                        <fa-icon [icon]="['far', 'truck']" class="text-sm opacity-70" />
                        <span class="text-sm font-bold leading-none">{{ versandRequirements.length }}</span>
                        <span class="text-sm opacity-70">Versand</span>
                      </span>
                      <span class="flex flex-row items-center gap-1">
                        <fa-icon [icon]="['far', 'layer-group']" class="text-sm opacity-70" />
                        <span class="text-sm font-bold leading-none">{{ stagingRequirements.length }}</span>
                        <span class="text-sm opacity-70">Staging</span>
                      </span>
                    </button>
                    <div class="grid grid-cols-2 gap-3 text-xs">
                      <!-- Versandartikel -->
                      <div class="flex flex-col gap-0.5 min-w-0">
                        <span class="opacity-60 font-semibold px-1">Versandartikel</span>
                        @for (req of versandRequirements; track req.id) {
                          <div
                            class="flex flex-row items-start gap-2 px-1 py-0.5 rounded hover:bg-base-200 cursor-pointer"
                            (click)="selectedTab = 'requirements'"
                          >
                            <fa-icon [icon]="['far', 'truck']" class="opacity-60 mt-0.5" />
                            <span class="flex-1 min-w-0 break-words">{{ req.article_template_description || req.free_text }}</span>
                            <span class="opacity-70 whitespace-nowrap">{{ req.quantity }}x</span>
                          </div>
                        } @empty {
                          <span class="opacity-50 px-1">keine</span>
                        }
                      </div>
                      <!-- Staging-Versandartikel -->
                      <div class="flex flex-col gap-0.5 min-w-0">
                        <span class="opacity-60 font-semibold px-1">Staging-Versandartikel</span>
                        @for (req of stagingRequirements; track req.id) {
                          <div
                            class="flex flex-row items-start gap-2 px-1 py-0.5 rounded hover:bg-base-200 cursor-pointer"
                            (click)="selectedTab = 'requirements'"
                          >
                            <fa-icon [icon]="['far', 'layer-group']" class="opacity-60 mt-0.5" />
                            <span class="flex-1 min-w-0 break-words">{{ req.article_template_description || req.free_text }}</span>
                            <span class="opacity-70 whitespace-nowrap">{{ req.quantity }}x</span>
                          </div>
                        } @empty {
                          <span class="opacity-50 px-1">keine</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300 col-span-2">
              <h3 class="bm-card-title bm-card-title-top flex flex-row gap-1 bg-base-100">
                <span> Technikerreport </span>
                <button
                  class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost opacity-25 hover:opacity-100"
                  (click)="editTechnicianReport = !editTechnicianReport"
                >
                  @if (editTechnicianReport) {
                    <fa-icon [icon]="['far', 'times']" />
                  } @else {
                    <fa-icon [icon]="['far', 'edit']" />
                  }
                </button>
              </h3>
              @if (editTechnicianReport) {
                <hawk-shared-edit-input
                  [textValue]="operation.report"
                  [modus]="'textarea'"
                  (saveClicked)="saveTechnicianReport($event)"
                  (cancelClicked)="editTechnicianReport = false"
                />
              } @else if (operation.report) {
                <div [innerHtml]="convertLinebreaks(operation.report, true)"></div>
              }
            </section>
          </div>
        }
        @if (selectedTab === "steps") {
          @for (md of operation.metadata; track $index) {
            <section class="bm-card bm-card-sm bm-card-body">
              <h3 class="bm-card-title">{{ md.name }}</h3>
              @if (parts) {
                <table class="bm-table bm-table-sm bm-table-zebra">
                  @for (step of md.steps; track $index) {
                    @if (false && step.value) {
                      <tr>
                        <td></td>
                        <td>
                          <pre>{{ step | json }}</pre>
                        </td>
                      </tr>
                    }
                    <!-- Fixes a problem that empty (and possibly non necessary steps) were rendered -->
                    @if (step.value) {
                      <tr>
                        <td style="width: 350px">{{ step.name }}</td>
                        <td>
                          @switch (step.stepType) {
                            @case ("yesNo") {
                              {{ step.value == true ? "Ja" : "nein" }}
                            }
                            @case ("timestamp") {
                              {{ step.value | date: "dd.MM.yyyy HH:mm:ss" }}
                            }
                            @case ("articleInput") {
                              Techniker will {{ countMaterials(step.value) }} Teile erfassen<br /><br />

                              erfasst wurden:
                              @for (v of step.value; track $index) {
                                <br />
                                {{ v.amount }}x: {{ v.selected?.title || "ohne Bezeichnung" }}, SNs:
                                {{ getSNForValueEntry(v.serialNumbers).join(", ") }} (SN erfasst:
                                {{ getSNForValueEntry(v.serialNumbers).length }}, nicht erfasst:
                                {{ v.amount - getSNForValueEntry(v.serialNumbers).length }})
                              }
                            }
                            @case ("articleRemoval") {
                              {{ countMaterials(step.value) }} Teil(e) ausgebaut
                            }
                            @case ("articleInstallation") {
                              @switch (articleInstallationFieldType(step.value)) {
                                @case ("sn_list") {
                                  @for (sn of step.value; track $index) {
                                    <hawk-operation-subpage-step-article
                                      [articleId]="sn"
                                    ></hawk-operation-subpage-step-article>
                                    <br />
                                  }
                                }
                                @case ("sn") {
                                  {{ step?.value?.sn?.description }}<br />
                                  <span>SN: </span>{{ step?.value?.sn?.serialNumber?.sn }}<br />
                                }
                                @case ("no_sn") {
                                  {{ step?.value?.no_sn?.amount || 0 }}x {{ step?.value?.no_sn?.description }}
                                }
                                @case ("noSn") {
                                  {{ step?.value?.noSn?.amount || 0 }}x {{ step?.value?.noSn?.description }}
                                }
                              }
                            }

                            @case ("photo") {
                              <a href="{{ getMetadataImagePath(step.value) }}" target="_blank">
                                <img [attr.src]="getMetadataImagePath(step.value)" class="metaImage" />
                              </a>
                            }
                            @case ("signature") {
                              <img [attr.src]="signaturePath(step.value)" />
                            }
                            @default {
                              {{ step.value }}
                            }
                          }
                        </td>
                      </tr>
                    }
                  }
                </table>
              }
            </section>
          }
        }
        @if (selectedTab === "operation_data") {
          <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
            <h3 class="bm-card-title flex flex-row justify-between items-center">
              <span>Einsatzdaten ({{ operationData.length }} Einträge)</span>
              <div class="flex gap-1">
                <button
                  class="bm-btn bm-btn-sm"
                  [class.bm-btn-primary]="operationDataSortMode === 'entry'"
                  [class.bm-btn-ghost]="operationDataSortMode !== 'entry'"
                  (click)="setOperationDataSortMode('entry')"
                  title="Sortierung nach Eintragungszeit"
                >
                  Nach Eintragung
                </button>
                <button
                  class="bm-btn bm-btn-sm"
                  [class.bm-btn-primary]="operationDataSortMode === 'location'"
                  [class.bm-btn-ghost]="operationDataSortMode !== 'location'"
                  (click)="setOperationDataSortMode('location')"
                  title="Sortierung nach Ort (Item SN, Type, Key)"
                >
                  Nach Ort
                </button>
              </div>
            </h3>
            @if (operationData.length > 0) {
              <div class="overflow-x-auto">
                <table class="bm-table bm-table-sm bm-table-zebra">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Item SN</th>
                      <th>Type & Key</th>
                      <th>Werte</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (data of operationData; track data.id) {
                      <tr>
                        <td class="font-mono text-xs">{{ data.id }}</td>
                        <td>{{ data.item_sn || "-" }}</td>
                        <td class="align-top">
                          @if (data.value_type) {
                            <div class="text-sm font-medium text-primary">{{ data.value_type }}</div>
                          }
                          @if (data.value_key) {
                            <div class="text-xs text-base-content/70">{{ data.value_key }}</div>
                          }
                          @if (!data.value_type && !data.value_key) {
                            <span class="text-base-content/50">-</span>
                          }
                        </td>
                        <td>
                          @for (valueEntry of getOperationDataValues(data); track valueEntry.key) {
                            <div class="text-sm mb-1">
                              <span class="font-semibold text-primary">{{ valueEntry.key }}:</span>
                              @if (valueEntry.type === "filename_image") {
                                <!-- FILENAME# Bild anzeigen -->
                                @if (extractFilenameFromBlob(valueEntry.value)) {
                                  <div class="ml-1 mt-1">
                                    <a
                                      [href]="getOperationImagePath(extractFilenameFromBlob(valueEntry.value)!)"
                                      target="_blank"
                                      class="inline-block"
                                    >
                                      <img
                                        [src]="getOperationImagePath(extractFilenameFromBlob(valueEntry.value)!)"
                                        [alt]="extractFilenameFromBlob(valueEntry.value)"
                                        class="max-h-[100px] border border-base-300 rounded"
                                        style="max-height: 100px"
                                      />
                                    </a>
                                    <div class="text-xs text-base-content/60 mt-1">
                                      {{ extractFilenameFromBlob(valueEntry.value) }}
                                    </div>
                                  </div>
                                }
                              } @else if (valueEntry.type === "base64_image") {
                                <!-- Base64 Bild anzeigen -->
                                <div class="ml-1 mt-1">
                                  <a
                                    href="javascript:void(0)"
                                    (click)="openBase64ImageInNewTab(valueEntry.value)"
                                    class="inline-block"
                                  >
                                    <img
                                      [src]="
                                        valueEntry.value.startsWith('data:')
                                          ? valueEntry.value
                                          : 'data:image/png;base64,' + valueEntry.value
                                      "
                                      alt="Base64 Image"
                                      class="max-h-[100px] border border-base-300 rounded"
                                      style="max-height: 100px"
                                    />
                                  </a>
                                  <div class="text-xs text-base-content/60 mt-1">
                                    Base64-Bild ({{ (valueEntry.value.length / 1024).toFixed(1) }}KB)
                                  </div>
                                </div>
                              } @else {
                                <!-- Normaler Text-Wert -->
                                <span class="ml-1">{{ valueEntry.value }}</span>
                              }
                            </div>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="text-center text-base-content/60 py-8">
                <p>Keine Einsatzdaten vorhanden</p>
              </div>
            }
          </section>
        }

        @if (selectedTab === "checklist" && checklistItems) {
          <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
            <div class="flex flex-col gap-2">
              <div class="flex flex-wrap items-center justify-between gap-3">
                <h3 class="bm-card-title">Checkliste: {{ checklist.name }}</h3>
                <div class="flex flex-wrap items-center gap-3">
                  <label class="text-sm text-base-content/70">Ansicht</label>
                  <select
                    class="bm-select bm-select-sm"
                    [(ngModel)]="checklistViewMode"
                    (ngModelChange)="onChecklistViewModeChange($event)"
                  >
                    <option value="compact">Kompakt</option>
                    <option value="expanded">Erweitert</option>
                    <option value="table">Tabelle</option>
                  </select>
                  <label class="bm-label cursor-pointer gap-2">
                    <input
                      type="checkbox"
                      class="bm-toggle bm-toggle-sm"
                      [(ngModel)]="checklistShowDebug"
                      (ngModelChange)="onChecklistDebugChange($event)"
                    />
                    <span class="text-sm">Debug</span>
                  </label>
                  <label class="bm-label cursor-pointer gap-2">
                    <input type="checkbox" class="bm-toggle bm-toggle-sm" [(ngModel)]="checklistHideUnanswered" />
                    <span class="text-sm">Nur beantwortete</span>
                  </label>
                </div>
              </div>

              @if (checklistViewMode === "table") {
                <div class="overflow-x-auto">
                  <table class="bm-table bm-table-sm">
                    <thead>
                      <tr>
                        @if (checklistShowDebug) {
                          <th class="w-24">ID</th>
                        }
                        <th>Frage</th>
                        <th>Antwort/Bild</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of getChecklistTableRows(); track row.questionText) {
                        <tr>
                          @if (checklistShowDebug) {
                            <td class="text-xs text-base-content/70">{{ row.questionId || "-" }}</td>
                          }
                          <td class="text-sm">{{ row.questionText }}</td>
                          <td>
                            @if (row.isEmpty || row.entries.length === 0) {
                              <div class="text-xs text-base-content/60 italic">Keine Antwort vorhanden</div>
                            } @else {
                              @for (data of row.entries; track data.id) {
                                <div class="mb-2">
                                  @if (!data.article || checklistShowDebug) {
                                    @for (val of getOperationDataValues(data); track val.key) {
                                      <div class="mb-1">
                                        @if (val.type === "filename_image") {
                                          <div class="mt-1">
                                            <a
                                              [href]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                              target="_blank"
                                            >
                                              <img
                                                [src]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                                class="max-h-[80px] border border-base-300 rounded"
                                              />
                                            </a>
                                          </div>
                                        } @else if (val.type === "base64_image") {
                                          <div class="mt-1">
                                            <img
                                              [src]="
                                                val.value.startsWith('data:')
                                                  ? val.value
                                                  : 'data:image/png;base64,' + val.value
                                              "
                                              class="max-h-[80px] border border-base-300 rounded"
                                            />
                                          </div>
                                        } @else {
                                          <span class="text-sm break-words">{{ val.value }}</span>
                                        }
                                      </div>
                                    }
                                  }

                                  @if (data.article) {
                                    <a
                                      [href]="'/a/artikel/' + data.article.id"
                                      target="_blank"
                                      [class]="'inline-block mt-1 p-2 rounded text-sm text-base-content transition-colors ' + (data.article.bad_part ? 'bg-red-50 hover:bg-red-100' : 'bg-base-200 hover:bg-base-300')"
                                    >
                                      @if (data.article.bad_part) {
                                        <div class="font-bold text-red-700">
                                          <fa-icon [icon]="['fas', 'bug']" class="mr-1" />
                                          {{ data.article.description || "Artikel" }}
                                        </div>
                                      } @else {
                                        <div class="font-bold">{{ data.article.description || "Artikel" }}</div>
                                      }
                                      @if (data.article.serial_number) {
                                        <div>SN: {{ data.article.serial_number }}</div>
                                      }
                                      @if (data.article.bad_part && data.article.bad_part_description) {
                                        <div class="text-xs text-red-600 italic">{{ data.article.bad_part_description }}</div>
                                      }
                                    </a>
                                  }

                                  @if (checklistShowDebug) {
                                    <div class="text-[11px] text-base-content/50">
                                      ID: {{ data.id }} · Type: {{ data.value_type }} · Key: {{ data.value_key }} ·
                                      Iteration: {{ data.iteration_id || "-" }} · Parent: {{ data.parent_id || "-" }}
                                    </div>
                                  }

                                  @if (getOperationDataAttachments(data).length > 0) {
                                    <div class="mt-1 flex flex-wrap gap-2">
                                      @for (att of getOperationDataAttachments(data); track att.id) {
                                        @if (
                                          att.filename.toLowerCase().endsWith(".jpg") ||
                                          att.filename.toLowerCase().endsWith(".jpeg") ||
                                          att.filename.toLowerCase().endsWith(".png") ||
                                          att.filename.toLowerCase().endsWith(".gif") ||
                                          att.filename.toLowerCase().endsWith(".webp") ||
                                          att.filename.toLowerCase().endsWith(".svg")
                                        ) {
                                          <a [href]="att.url" target="_blank" class="block">
                                            <img
                                              [src]="att.url"
                                              class="h-16 w-auto object-cover rounded"
                                              [title]="att.filename"
                                            />
                                          </a>
                                        } @else {
                                          <a [href]="att.url" target="_blank" class="bm-btn bm-btn-xs bm-btn-outline">
                                            {{ att.filename }}
                                          </a>
                                        }
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              } @else if (checklistViewMode === "expanded") {
                <div class="flex flex-col gap-4">
                  @for (item of getChecklistItemsForDisplay(); track item.id) {
                    <div class="bm-card bm-card-sm bm-card-border border-base-200">
                      <div class="bm-card-body p-4">
                        <h4 class="font-bold text-lg mb-2">
                          <span class="text-gray-500 mr-2">#{{ item.id }}</span>
                          {{ item.text }}
                        </h4>

                        @if (item.item_type === "subchecklist") {
                          @if (getSubchecklistIterations(item).length > 0) {
                            @for (iteration of getSubchecklistIterations(item); track iteration.iterationKey) {
                              @if (!checklistHideUnanswered || groupHasAnswers(iteration.entries)) {
                                <div class="ml-4 mb-4">
                                  <div class="text-xs text-base-content/60 mb-2">{{ iteration.label }}</div>
                                  @for (
                                    group of getSubchecklistQuestionGroups(iteration.entries);
                                    track group.questionKey
                                  ) {
                                    @if (!checklistHideUnanswered || groupHasAnswers(group.entries)) {
                                      <div class="ml-4 mb-3 border-l-2 border-primary pl-3">
                                        <div class="font-semibold text-sm mb-1">{{ group.label }}</div>
                                        @for (data of group.entries; track data.id) {
                                          <div class="mb-2">
                                            @if (!data.article || checklistShowDebug) {
                                              @for (val of getOperationDataValues(data); track val.key) {
                                                <div class="mb-1">
                                                  @if (val.type === "filename_image") {
                                                  <div class="mt-2">
                                                    <span class="text-xs text-gray-500 block mb-1"
                                                      >Bild: {{ extractFilenameFromBlob(val.value) }}</span
                                                    >
                                                    <a
                                                      [href]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                                      target="_blank"
                                                    >
                                                      <img
                                                        [src]="
                                                          getOperationImagePath(extractFilenameFromBlob(val.value))
                                                        "
                                                        class="max-w-xs rounded shadow-sm hover:scale-105 transition-transform"
                                                      />
                                                    </a>
                                                  </div>
                                                } @else if (val.type === "base64_image") {
                                                  <div class="mt-2">
                                                    <button
                                                      class="bm-btn bm-btn-xs bm-btn-outline"
                                                      (click)="openBase64ImageInNewTab(val.value)"
                                                    >
                                                      Bild anzeigen
                                                    </button>
                                                    <img
                                                      [src]="
                                                        val.value.startsWith('data:')
                                                          ? val.value
                                                          : 'data:image/png;base64,' + val.value
                                                      "
                                                      class="block mt-1 max-w-xs rounded shadow-sm"
                                                    />
                                                  </div>
                                                } @else {
                                                  <div class="text-base break-words">{{ val.value }}</div>
                                                }
                                              </div>
                                              }
                                            }

                                            @if (data.article) {
                                              <a
                                                [href]="'/a/artikel/' + data.article.id"
                                                target="_blank"
                                                [class]="'inline-block mt-1 p-2 rounded text-sm text-base-content transition-colors ' + (data.article.bad_part ? 'bg-red-50 hover:bg-red-100' : 'bg-base-200 hover:bg-base-300')"
                                              >
                                                @if (data.article.bad_part) {
                                                  <div class="font-bold text-red-700">
                                                    <fa-icon [icon]="['fas', 'bug']" class="mr-1" />
                                                    {{ data.article.description || "Artikel" }}
                                                  </div>
                                                } @else {
                                                  <div class="font-bold">{{ data.article.description || "Artikel" }}</div>
                                                }
                                                @if (data.article.serial_number) {
                                                  <div>SN: {{ data.article.serial_number }}</div>
                                                }
                                                @if (data.article.bad_part && data.article.bad_part_description) {
                                                  <div class="text-xs text-red-600 italic">{{ data.article.bad_part_description }}</div>
                                                }
                                              </a>
                                            }

                                            @if (checklistShowDebug) {
                                              <div class="text-xs text-gray-400 mt-1 flex gap-2">
                                                <span>ID: {{ data.id }}</span>
                                                <span>Type: {{ data.value_type }}</span>
                                                <span>Key: {{ data.value_key }}</span>
                                                <span>Iteration: {{ data.iteration_id || "-" }}</span>
                                                <span>Parent: {{ data.parent_id || "-" }}</span>
                                              </div>
                                            }

                                            @if (getOperationDataAttachments(data).length > 0) {
                                              <div class="mt-2">
                                                <span class="text-xs font-bold block mb-1">Anhänge:</span>
                                                <div class="flex flex-wrap gap-2">
                                                  @for (att of getOperationDataAttachments(data); track att.id) {
                                                    @if (
                                                      att.filename.toLowerCase().endsWith(".jpg") ||
                                                      att.filename.toLowerCase().endsWith(".jpeg") ||
                                                      att.filename.toLowerCase().endsWith(".png") ||
                                                      att.filename.toLowerCase().endsWith(".gif") ||
                                                      att.filename.toLowerCase().endsWith(".webp") ||
                                                      att.filename.toLowerCase().endsWith(".svg")
                                                    ) {
                                                      <a [href]="att.url" target="_blank" class="block">
                                                        <img
                                                          [src]="att.url"
                                                          class="h-20 w-auto object-cover rounded shadow-sm hover:scale-105 transition-transform"
                                                          [title]="att.filename"
                                                        />
                                                      </a>
                                                    } @else {
                                                      <a
                                                        [href]="att.url"
                                                        target="_blank"
                                                        class="bm-btn bm-btn-xs bm-btn-outline gap-1"
                                                      >
                                                        {{ att.filename }}
                                                      </a>
                                                    }
                                                  }
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  }
                                </div>
                              }
                            }
                          } @else {
                            <div class="ml-4 text-gray-400 italic text-sm">Keine Antwort vorhanden</div>
                          }
                        } @else {
                          @for (data of getOperationDataForQuestion(item); track data.id) {
                            <div class="ml-6 mb-4 border-l-2 border-primary pl-4">
                              @if (!data.article || checklistShowDebug) {
                                @for (val of getOperationDataValues(data); track val.key) {
                                  <div class="mb-1">
                                    @if (val.type === "filename_image") {
                                      <div class="mt-2">
                                        <span class="text-xs text-gray-500 block mb-1"
                                          >Bild: {{ extractFilenameFromBlob(val.value) }}</span
                                        >
                                        <a
                                          [href]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                          target="_blank"
                                        >
                                          <img
                                            [src]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                            class="max-w-xs rounded shadow-sm hover:scale-105 transition-transform"
                                          />
                                        </a>
                                      </div>
                                    } @else if (val.type === "base64_image") {
                                      <div class="mt-2">
                                        <button
                                          class="bm-btn bm-btn-xs bm-btn-outline"
                                          (click)="openBase64ImageInNewTab(val.value)"
                                        >
                                          Bild anzeigen
                                        </button>
                                        <img
                                          [src]="
                                            val.value.startsWith('data:')
                                              ? val.value
                                              : 'data:image/png;base64,' + val.value
                                          "
                                          class="block mt-1 max-w-xs rounded shadow-sm"
                                        />
                                      </div>
                                    } @else {
                                      <div class="text-base break-words">{{ val.value }}</div>
                                    }
                                  </div>
                                }
                              }

                              @if (checklistShowDebug) {
                                <div class="text-xs text-gray-400 mt-1 flex gap-2">
                                  <span>ID: {{ data.id }}</span>
                                  <span>Type: {{ data.value_type }}</span>
                                  <span>Key: {{ data.value_key }}</span>
                                  <span>Iteration: {{ data.iteration_id || "-" }}</span>
                                  <span>Parent: {{ data.parent_id || "-" }}</span>
                                </div>
                              }

                              @if (getOperationDataAttachments(data).length > 0) {
                                <div class="mt-2">
                                  <span class="text-xs font-bold block mb-1">Anhänge:</span>
                                  <div class="flex flex-wrap gap-2">
                                    @for (att of getOperationDataAttachments(data); track att.id) {
                                      @if (
                                        att.filename.toLowerCase().endsWith(".jpg") ||
                                        att.filename.toLowerCase().endsWith(".jpeg") ||
                                        att.filename.toLowerCase().endsWith(".png") ||
                                        att.filename.toLowerCase().endsWith(".gif") ||
                                        att.filename.toLowerCase().endsWith(".webp") ||
                                        att.filename.toLowerCase().endsWith(".svg")
                                      ) {
                                        <a [href]="att.url" target="_blank" class="block">
                                          <img
                                            [src]="att.url"
                                            class="h-20 w-auto object-cover rounded shadow-sm hover:scale-105 transition-transform"
                                            [title]="att.filename"
                                          />
                                        </a>
                                      } @else {
                                        <a
                                          [href]="att.url"
                                          target="_blank"
                                          class="bm-btn bm-btn-xs bm-btn-outline gap-1"
                                        >
                                          {{ att.filename }}
                                        </a>
                                      }
                                    }
                                  </div>
                                </div>
                              }

                              @if (data.article) {
                                <a
                                  [href]="'/a/artikel/' + data.article.id"
                                  target="_blank"
                                  [class]="'block mt-2 p-2 rounded text-sm text-base-content transition-colors ' + (data.article.bad_part ? 'bg-red-50 hover:bg-red-100' : 'bg-base-200 hover:bg-base-300')"
                                >
                                  @if (data.article.bad_part) {
                                    <div class="font-bold text-red-700">
                                      <fa-icon [icon]="['fas', 'bug']" class="mr-1" />
                                      {{ data.article.description || "Artikel" }}
                                    </div>
                                  } @else {
                                    <div class="font-bold">{{ data.article.description || "Artikel" }}</div>
                                  }
                                  @if (data.article.serial_number) {
                                    <div>SN: {{ data.article.serial_number }}</div>
                                  }
                                  @if (data.article.bad_part && data.article.bad_part_description) {
                                    <div class="text-xs text-red-600 italic">{{ data.article.bad_part_description }}</div>
                                  }
                                </a>
                              }
                            </div>
                          } @empty {
                            <div class="ml-6 text-gray-400 italic text-sm">Keine Antwort vorhanden</div>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="flex flex-col gap-3">
                  @for (item of getChecklistItemsForDisplay(); track item.id) {
                    <div class="border-b border-base-200 pb-2">
                      <div class="text-sm font-semibold">
                        <span class="text-base-content/60 mr-2">#{{ item.id }}</span>
                        {{ item.text }}
                      </div>

                      @if (item.item_type === "subchecklist") {
                        @if (getSubchecklistIterations(item).length > 0) {
                          @for (iteration of getSubchecklistIterations(item); track iteration.iterationKey) {
                            @if (!checklistHideUnanswered || groupHasAnswers(iteration.entries)) {
                              <div class="mt-2 ml-4">
                                <div class="text-xs text-base-content/60 mb-1">{{ iteration.label }}</div>
                                @for (
                                  group of getSubchecklistQuestionGroups(iteration.entries);
                                  track group.questionKey
                                ) {
                                  @if (!checklistHideUnanswered || groupHasAnswers(group.entries)) {
                                    <div class="ml-3 mb-2">
                                      <div class="text-xs font-semibold">{{ group.label }}</div>
                                      @for (data of group.entries; track data.id) {
                                        <div class="ml-2">
                                          @if (!data.article || checklistShowDebug) {
                                            @for (val of getOperationDataValues(data); track val.key) {
                                              <div class="mb-1">
                                                @if (val.type === "filename_image") {
                                                  <div class="mt-1">
                                                    <a
                                                      [href]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                                      target="_blank"
                                                    >
                                                      <img
                                                        [src]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                                        class="max-h-[80px] border border-base-300 rounded"
                                                      />
                                                    </a>
                                                  </div>
                                                } @else if (val.type === "base64_image") {
                                                  <div class="mt-1">
                                                    <img
                                                      [src]="
                                                        val.value.startsWith('data:')
                                                          ? val.value
                                                          : 'data:image/png;base64,' + val.value
                                                      "
                                                      class="max-h-[80px] border border-base-300 rounded"
                                                    />
                                                  </div>
                                                } @else {
                                                  <span class="text-sm break-words">{{ val.value }}</span>
                                                }
                                              </div>
                                            }
                                          }

                                          @if (data.article) {
                                            <a
                                              [href]="'/a/artikel/' + data.article.id"
                                              target="_blank"
                                              [class]="'inline-block mt-1 p-2 rounded text-sm text-base-content transition-colors ' + (data.article.bad_part ? 'bg-red-50 hover:bg-red-100' : 'bg-base-200 hover:bg-base-300')"
                                            >
                                              @if (data.article.bad_part) {
                                                <div class="font-bold text-red-700">
                                                  <fa-icon [icon]="['fas', 'bug']" class="mr-1" />
                                                  {{ data.article.description || "Artikel" }}
                                                </div>
                                              } @else {
                                                <div class="font-bold">{{ data.article.description || "Artikel" }}</div>
                                              }
                                              @if (data.article.serial_number) {
                                                <div>SN: {{ data.article.serial_number }}</div>
                                              }
                                              @if (data.article.bad_part && data.article.bad_part_description) {
                                                <div class="text-xs text-red-600 italic">{{ data.article.bad_part_description }}</div>
                                              }
                                            </a>
                                          }

                                          @if (checklistShowDebug) {
                                            <div class="text-[11px] text-base-content/50">
                                              ID: {{ data.id }} · Type: {{ data.value_type }} · Key:
                                              {{ data.value_key }} · Iteration: {{ data.iteration_id || "-" }} · Parent:
                                              {{ data.parent_id || "-" }}
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                }
                              </div>
                            }
                          }
                        } @else {
                          <div class="ml-4 text-xs text-base-content/60 italic">Keine Antwort vorhanden</div>
                        }
                      } @else {
                        @for (data of getOperationDataForQuestion(item); track data.id) {
                          <div class="ml-4 mt-1">
                            @if (!data.article || checklistShowDebug) {
                              @for (val of getOperationDataValues(data); track val.key) {
                                <div class="mb-1">
                                  @if (val.type === "filename_image") {
                                    <div class="mt-1">
                                      <a
                                        [href]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                        target="_blank"
                                      >
                                        <img
                                          [src]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                          class="max-h-[80px] border border-base-300 rounded"
                                        />
                                      </a>
                                    </div>
                                  } @else if (val.type === "base64_image") {
                                    <div class="mt-1">
                                      <img
                                        [src]="
                                          val.value.startsWith('data:') ? val.value : 'data:image/png;base64,' + val.value
                                        "
                                        class="max-h-[80px] border border-base-300 rounded"
                                      />
                                    </div>
                                  } @else {
                                    <span class="text-sm break-words">{{ val.value }}</span>
                                  }
                                </div>
                              }
                            }

                            @if (data.article) {
                              <a
                                [href]="'/a/artikel/' + data.article.id"
                                target="_blank"
                                [class]="'inline-block mt-1 p-2 rounded text-sm text-base-content transition-colors ' + (data.article.bad_part ? 'bg-red-50 hover:bg-red-100' : 'bg-base-200 hover:bg-base-300')"
                              >
                                @if (data.article.bad_part) {
                                  <div class="font-bold text-red-700">
                                    <fa-icon [icon]="['fas', 'bug']" class="mr-1" />
                                    {{ data.article.description || "Artikel" }}
                                  </div>
                                } @else {
                                  <div class="font-bold">{{ data.article.description || "Artikel" }}</div>
                                }
                                @if (data.article.serial_number) {
                                  <div>SN: {{ data.article.serial_number }}</div>
                                }
                                @if (data.article.bad_part && data.article.bad_part_description) {
                                  <div class="text-xs text-red-600 italic">{{ data.article.bad_part_description }}</div>
                                }
                              </a>
                            }

                            @if (checklistShowDebug) {
                              <div class="text-[11px] text-base-content/50">
                                ID: {{ data.id }} · Type: {{ data.value_type }} · Key: {{ data.value_key }} · Iteration:
                                {{ data.iteration_id || "-" }} · Parent: {{ data.parent_id || "-" }}
                              </div>
                            }
                          </div>
                        } @empty {
                          <div class="ml-4 text-xs text-base-content/60 italic">Keine Antwort vorhanden</div>
                        }
                      }
                    </div>
                  }
                </div>
              }
            </div>

            @if (getUnmatchedOperationData().length > 0) {
              <div class="mt-4 border-t border-warning/30 pt-4">
                <h4 class="text-sm font-semibold text-warning mb-2">
                  <fa-icon [icon]="['far', 'exclamation-triangle']" class="mr-1" />
                  Nicht zugeordnete Einträge ({{ getUnmatchedOperationData().length }})
                </h4>
                <div class="flex flex-col gap-2">
                  @for (data of getUnmatchedOperationData(); track data.id) {
                    <div class="ml-4 p-2 bg-warning/5 rounded border border-warning/20">
                      <div class="flex items-start gap-2">
                        <div class="flex-1">
                          @if (data.checklist_item?.text) {
                            <div class="text-sm font-medium">{{ data.checklist_item.text }}</div>
                          }
                          @if (!data.article || checklistShowDebug) {
                            @for (val of getOperationDataValues(data); track val.key) {
                              <div class="text-sm">
                                @if (val.type === "filename_image") {
                                  <a
                                    [href]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                    target="_blank"
                                  >
                                    <img
                                      [src]="getOperationImagePath(extractFilenameFromBlob(val.value))"
                                      class="max-h-[60px] border border-base-300 rounded"
                                    />
                                  </a>
                                } @else if (val.type === "base64_image") {
                                  <img
                                    [src]="val.value.startsWith('data:') ? val.value : 'data:image/png;base64,' + val.value"
                                    class="max-h-[60px] border border-base-300 rounded"
                                  />
                                } @else {
                                  <span class="break-words">{{ val.value }}</span>
                                }
                              </div>
                            }
                          }
                          @if (data.article) {
                            <a
                              [href]="'/a/artikel/' + data.article.id"
                              target="_blank"
                              [class]="'inline-block mt-1 p-2 rounded text-sm transition-colors ' + (data.article.bad_part ? 'bg-red-50 hover:bg-red-100' : 'bg-base-200 hover:bg-base-300')"
                            >
                              @if (data.article.bad_part) {
                                <div class="font-bold text-red-700">
                                  <fa-icon [icon]="['fas', 'bug']" class="mr-1" />
                                  {{ data.article.description || "Artikel" }}
                                </div>
                              } @else {
                                <div class="font-bold">{{ data.article.description || "Artikel" }}</div>
                              }
                              @if (data.article.serial_number) {
                                <div>SN: {{ data.article.serial_number }}</div>
                              }
                              @if (data.article.bad_part && data.article.bad_part_description) {
                                <div class="text-xs text-red-600 italic">{{ data.article.bad_part_description }}</div>
                              }
                            </a>
                          }
                        </div>
                        <div class="text-[11px] text-base-content/40 text-right whitespace-nowrap">
                          {{ data.value_type }}<br />
                          Key: {{ data.value_key }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </section>
        }
        @if (selectedTab === "mt_result") {
          <!-- FIXME: PUT COMPONENT HERE -->
          <app-mt-result [ticketId]="ticket.id" />
        }
        @if (selectedTab === "requirements") {
          <div class="p-4">
            <app-operation-shipping-matrix
              [operationId]="operation.id"
              [projectId]="ticket.project_id"
              [ticketStoreId]="ticket.store_id"
              [ticketLat]="ticket.address_latitude"
              [ticketLng]="ticket.address_longitude"
              [referenceDate]="operation.operation_date"
              [operationTechnicianId]="operation.technicians?.[0]?.id"
              [operationTechnicianName]="operation.technicians?.[0]?.full_name"
            />
          </div>
        }
        @if (selectedTab === "material") {
          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col gap-4">
              @if (newMaterialForm) {
                <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                  <h3 class="bm-card-title">
                    Neues Material hinzufügen
                    <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="newMaterialForm = false">
                      <fa-icon [icon]="['far', 'times']" />
                    </button>
                  </h3>
                  <table class="bm-table bm-table-sm">
                    <tr *ngShow="false">
                      <td class="w-0">Artikelnummer</td>
                      <td><input type="text" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.item_nr" /></td>
                    </tr>
                    <tr>
                      <td wdith="0">Typ</td>
                      <td>
                        @if (!newMaterialSelectedArticle) {
                          <span>keiner ausgewählt</span>
                        }
                        @if (newMaterialSelectedArticle) {
                          <span
                            >{{ formatArticleTemplate(newMaterialSelectedArticle) }}
                            <a href="" class="technicianAction" (click)="unselectMaterialArticleTemplate()">
                              <fa-icon [icon]="['fas', 'times']" /> </a
                          ></span>
                        }
                        <br />
                        @if (!newMaterialSelectedArticle) {
                          <input
                            type="text"
                            class="bm-input bm-input-sm"
                            [(ngModel)]="newMaterialTerm"
                            placeholder="Suchbegriff eingeben"
                          /><br />
                          <small><b>zum Suchbegriff passende Artikel:</b></small
                          ><br />
                          @for (
                            articleTemplate of articleTemplates | articleTemplateFilter: newMaterialTerm | slice: 0 : 5;
                            track articleTemplate
                          ) {
                            <small>{{ formatArticleTemplate(articleTemplate) }}</small>
                            <a
                              href=""
                              class="technicianAction"
                              (click)="selectMaterialArticleTemplate(articleTemplate)"
                            >
                              <fa-icon [icon]="['fas', 'check-square']" />
                            </a>
                            <br />
                          }
                        }
                      </td>
                    </tr>
                    <tr *ngShow="false">
                      <td class="w-0">Beschreibung</td>
                      <td><input type="text" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.description" /></td>
                    </tr>
                    <tr>
                      <td class="w-0">Anzahl</td>
                      <td><input type="number" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.amount" /></td>
                    </tr>
                    <tr *ngShow="false">
                      <td class="w-0">Status</td>
                      <td>
                        <select
                          name="status"
                          id="status"
                          class="bm-select bm-select-sm"
                          [(ngModel)]="newMaterial.status"
                        >
                          @for (status of materialStatusOptions; track status) {
                            <option [value]="status" [selected]="status === newMaterial.status">
                              {{ status }}
                            </option>
                          }
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="w-0">Seriennummer</td>
                      <td><input type="text" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.sn" /></td>
                    </tr>
                    <tr>
                      <td class="w-0"></td>
                      <td>
                        <button class="bm-btn bm-btn-primary" (click)="saveMaterial()">Speichern</button>
                      </td>
                    </tr>
                  </table>
                </section>
              }
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title">
                  Benötigtes Material Techniker
                  <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="newMaterialForm = true">
                    <fa-icon [icon]="['far', 'plus']" />
                  </button>
                </h3>
                <table class="bm-table bm-table-sm">
                  <tr>
                    <th>Typ</th>
                    <th>Anzahl</th>
                    <th>Status</th>
                    <th>Beschreibung</th>
                    <th>SN</th>
                    <th>ArtNr</th>
                  </tr>
                  @for (material of ticket.material; track $index) {
                    <tr>
                      <td>{{ material.title }}</td>
                      <td>{{ material.amount }}</td>
                      <td>{{ material.status }}</td>
                      <td>{{ material.description }}</td>
                      <td>{{ material.sn }}</td>
                      <td>{{ material.item_nr }}</td>
                    </tr>
                  }
                </table>
              </section>
            </div>

            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title">Materialeingang</h3>
              <table class="bm-table bm-table-sm">
                <tr>
                  <th class="w-0">Typ</th>
                  <th class="w-0">Anzahl</th>
                  <th>Seriennummern</th>
                </tr>
                @for (article of []; track article) {
                  <tr>
                    <td class="w-0">{{ article.title }}</td>
                    <td class="w-0">{{ article.amount }}</td>
                    <td>
                      @for (sn of article.serial_numbers; track sn) {
                        <span>{{ sn }}</span>
                      }
                    </td>
                  </tr>
                }
              </table>
            </section>
            @if (articleSummary) {
              <div class="flex flex-row gap-4 col-span-2">
                @if (articleSummary.article_input_compact) {
                  <section class="flex-fill bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                    <h3 class="bm-card-title">Zusammenfassung Material Eingang (Ticket)</h3>
                    <table class="bm-table bm-table-sm">
                      <tr>
                        <th class="w-0">Anzahl</th>
                        <th>Typ</th>
                      </tr>
                      @for (article of keysFor(articleSummary.article_input_compact); track article) {
                        <tr>
                          <td class="w-0">{{ articleSummary.article_input_compact[article]?.length }}x</td>
                          <td>{{ article }}</td>
                        </tr>
                      }
                    </table>
                  </section>
                }
                @if (articleSummary.article_installation_compact) {
                  <section class="flex-fill bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                    <h3 class="bm-card-title">Zusammenfassung Material Installation (Ticket)</h3>
                    <table class="bm-table bm-table-sm">
                      <tr>
                        <th class="w-0">Anzahl</th>
                        <th>Typ</th>
                      </tr>
                      @for (article of keysFor(articleSummary.article_installation_compact); track article) {
                        <tr class="align-top">
                          <td class="w-0">{{ articleSummary.article_installation_compact[article]?.length }}x</td>
                          <td>
                            <button type="button"
                                    class="bm-btn bm-btn-ghost bm-btn-xs px-1 text-left"
                                    (click)="toggleInstallationDetails(article)">
                              {{ isInstallationExpanded(article) ? '▾' : '▸' }} {{ cleanString(article) }}
                            </button>
                            @if (isInstallationExpanded(article)) {
                              <ul class="text-xs mt-1 ml-3 flex flex-col gap-1">
                                @for (item of articleSummary.article_installation_compact[article]; track item.handling_id) {
                                  <li class="flex items-center gap-2">
                                    <span class="font-mono opacity-80">SN: {{ item.sn || '-' }}</span>
                                    @if (item.handling_id) {
                                      <button type="button"
                                              class="bm-btn bm-btn-ghost bm-btn-xs text-error ml-auto"
                                              (click)="openCancelDialog(item.handling_id, article, item.sn)">
                                        Stornieren
                                      </button>
                                    }
                                  </li>
                                }
                              </ul>
                            }
                          </td>
                        </tr>
                      }
                    </table>
                  </section>
                }
                @if (articleSummary.article_removal_compact) {
                  <section class="flex-fill bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                    <h3 class="bm-card-title">Zusammenfassung Material Ausbau (Ticket)</h3>
                    <table class="bm-table bm-table-sm">
                      <tr>
                        <th class="w-0">Anzahl</th>
                        <th>Typ</th>
                      </tr>
                      @for (article of keysFor(articleSummary.article_removal_compact); track article) {
                        <tr>
                          <td class="w-0">{{ articleSummary.article_removal_compact[article]?.length }}x</td>
                          <td>{{ article }}</td>
                        </tr>
                      }
                    </table>
                  </section>
                }
              </div>
            }
            <div class="flex flex-col gap-4 col-span-2">
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title bm-card-title-top bg-base-100 flex flex-row gap-1">
                  <span> Gewechselte Teile </span>
                  <button
                    class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-tooltip"
                    data-tip="Neues Teil"
                    (click)="newPartForm = true"
                  >
                    <fa-icon [icon]="['far', 'plus']" />
                  </button>
                </h3>
                @if (parts) {
                  <div class="overflow-y-auto" [style.max-height.px]="400">
                    <table class="bm-table bm-table-sm bm-table-pin-rows">
                      <thead>
                        <tr>
                          <th>RMA</th>
                          <th>Typ</th>
                          <th>SN eingebaut</th>
                          <th>SN ausgebaut</th>
                          <th>Fehlerbeschreibung</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (part of parts; track $index) {
                          @if (part !== selectedPart) {
                            <tr>
                              @if (part.article) {
                                <td>
                                  <a href="/a/artikel/{{ part.article?.id }}" target="_blank">{{ part.rma }}</a>
                                </td>
                              } @else {
                                <td>{{ part.rma }}</td>
                              }
                              <td>{{ part.article?.description }}</td>
                              <td>{{ part.newsn }}</td>
                              <td>{{ part.oldsn }}</td>
                              <td>{{ part.description }}</td>
                            </tr>
                          }
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </section>
              @if (newPartForm) {
                <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                  <h3 class="bm-card-title flex flex-row gap-1">
                    <span class="flex-1"> Neues Teil auswählen </span>
                    <button class="bm-btn bm-btn-sm bm-btn-ghost" (click)="newPartForm = false">
                      <fa-icon [icon]="['far', 'times']" />
                    </button>
                  </h3>
                  <dl class="bm-dl">
                    <dt>Artikeltyp</dt>
                    <dd>
                      @if (newSelectedArticleTemplate) {
                        <div class="flex flex-row gap-1 items-center">
                          {{ formatArticleTemplate(newSelectedArticleTemplate) }}
                          <button
                            type="button"
                            class="bm-btn bm-btn-square bm-btn-sm bm-btn-ghost"
                            (click)="unselectPartArticleTemplate()"
                          >
                            <fa-icon [icon]="['fas', 'times']" />
                          </button>
                        </div>
                      } @else {
                        <span>keiner ausgewählt</span>
                        <fieldset class="bm-fieldset">
                          <input
                            type="text"
                            class="bm-input"
                            [(ngModel)]="newArticleTemplateTerm"
                            placeholder="Suchbegriff eingeben"
                          />
                          <p class="bm-label">zum Suchbegriff passende Artikeltypen:</p>
                          @for (
                            articleTemplate of articleTemplates
                              | articleTemplateFilter: newArticleTemplateTerm
                              | slice: 0 : 20;
                            track $index
                          ) {
                            <div
                              class="flex flex-row gap-1 items-center"
                              (click)="selectPartArticleTemplate(articleTemplate)"
                            >
                              {{ formatArticleTemplate(articleTemplate) }}
                              <button type="button" class="bm-btn bm-btn-square bm-btn-sm bm-btn-ghost">
                                <fa-icon [icon]="['fas', 'check-square']" />
                              </button>
                            </div>
                          }
                        </fieldset>
                      }
                    </dd>
                    @if (newSelectedArticleTemplate) {
                      <dt>Artikel</dt>
                      <dd>
                        @if (badPartOnly) {
                          <span>nur Badpart erfassen</span>
                        } @else if (newPartSelectedArticle) {
                          <div>
                            {{ formatArticle(newPartSelectedArticle) }}
                            <button
                              type="button"
                              class="bm-btn bm-btn-square bm-btn-sm bm-btn-ghost"
                              (click)="unselectPartArticle()"
                            >
                              <fa-icon [icon]="['fas', 'times']" />
                            </button>
                          </div>

                          <button class="my-2 bm-btn bm-btn-primary" (click)="selectOnlyBadpart()">
                            Keinen Einbau erfassen, nur Badpart
                          </button>
                        } @else {
                          <span>keiner ausgewählt</span>
                          <fieldset class="bm-fieldset">
                            <input
                              type="text"
                              class="bm-input"
                              [(ngModel)]="newPartTerm"
                              placeholder="Suchbegriff eingeben"
                            />

                            <span class="bm-label">zum Suchbegriff passende Artikeltypen:</span>

                            @for (
                              article of searchArticles | articleFilter: newPartTerm | slice: 0 : sliceCountArticles;
                              track $index
                            ) {
                              <div (click)="selectPartArticle(article)">
                                {{ formatArticle(article) }}
                                <button type="button" class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
                                  <fa-icon [icon]="['fas', 'check-square']" />
                                </button>
                              </div>
                            }
                            <a class="bm-link bm-link-ghost" (click)="increaseArticleSliceCount()"> mehr laden </a>
                          </fieldset>

                          <button
                            type="button"
                            class="bm-btn bm-btn-sm bm-btn-primary mt-4"
                            (click)="selectOnlyBadpart()"
                          >
                            Keinen Einbau erfassen, nur Badpart
                          </button>
                        }
                      </dd>
                      @if (newPartSelectedArticle || badPartOnly) {
                        <dt>SN ausgebaut</dt>
                        <dd>
                          <input type="text" class="bm-input bm-input-sm mb-1" [(ngModel)]="newPart.sn_removed" />
                        </dd>
                        <dt>Fehlerbeschreibung</dt>
                        <dd>
                          <input
                            type="text"
                            class="bm-input bm-input-sm mb-1"
                            [(ngModel)]="newPart.error_description"
                          />
                        </dd>
                        <dt></dt>
                        <dd>
                          <button
                            type="input"
                            class="bm-btn bm-btn-primary"
                            (click)="savePart()"
                            [disabled]="newPart.article_id === null && !badPartOnly"
                          >
                            Speichern
                          </button>
                        </dd>
                      }
                    }
                  </dl>
                </section>
              }
            </div>
          </div>
        }
        @if (selectedTab === "delivery_notes") {
          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col gap-4">
              @if (linkDeliveryNoteForm) {
                <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                  <h3 class="bm-card-title">Lieferschein verlinken</h3>
                  <label class="bm-fieldset-label"> Lieferscheinnummer angeben (z.B. LS-2021-00815) </label>
                  <input type="text" class="bm-input bm-input-sm" [(ngModel)]="deliveryNoteNumberToLink" />
                  <div class="flex flex-row gap-1">
                    <button class="bm-btn" (click)="linkDeliveryNoteForm = false">Abbrechen</button>
                    <button class="bm-btn bm-btn-primary" (click)="linkDeliveryNote()">Speichern</button>
                  </div>
                </section>
              }
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title flex flex-row items-center gap-1">
                  <span class="flex-fill"> Lieferscheine </span>
                  <button class="bm-btn" (click)="linkDeliveryNoteForm = true">
                    <fa-icon [icon]="['far', 'link']" />
                    Lieferschein verlinken
                  </button>
                  <button class="bm-btn" (click)="navigateNewDN()">
                    <fa-icon [icon]="['far', 'plus']" />
                    Neuer Lieferschein
                  </button>
                </h3>
                <table class="bm-table bm-table-sm">
                  @for (dn of ticket.delivery_notes; track dn) {
                    <tr>
                      <td>
                        <a [routerLink]="['/', 'lieferscheine', dn.id]" target="_blank">
                          <fa-icon [icon]="['far', 'truck']" />
                          {{ dn.number }}
                        </a>
                      </td>
                      <td>
                        @switch (dn.note_type) {
                          @case ("incoming") {
                            <span class="shippingLabel shippingLabel-info">Entgegengenommen</span>
                          }
                          @case ("installed") {
                            <span class="shippingLabel shippingLabel-info">Eingebaut</span>
                          }
                          @case ("removed") {
                            <span class="shippingLabel shippingLabel-info">Ausgebaut</span>
                          }
                          @case ("returned") {
                            <span class="shippingLabel shippingLabel-info">Zurückgeschickt</span>
                          }
                        }
                      </td>
                      <td>
                        @switch (dn.shipcloud_tracking_status) {
                          @case ("UNKNOWN") {
                            <span class="shippingLabel shippingLabel-default">Unbekannt</span>
                          }
                          @case ("TRANSIT") {
                            <span class="shippingLabel shippingLabel-warning">Unterwegs</span>
                          }
                          @case ("OUT_FOR_DELIVERY") {
                            <span class="shippingLabel shippingLabel-warning">In Zustellung</span>
                          }
                          @case ("DELIVERED") {
                            <span class="shippingLabel shippingLabel-success">Zugestellt</span>
                          }
                        }
                        <a
                          href="/warehouse/deliveryNote/{{ dn.id }}/checkShipcloudTrackingStatus"
                          target="_blank"
                          (click)="reloadDeliveryNotes()"
                          style="margin-left: 5px"
                        >
                          <fa-icon [icon]="['far', 'sync-alt']" />
                        </a>
                      </td>
                      <td>
                        @if (dn.shipcloud_tracking_url) {
                          <a href="{{ dn.shipcloud_tracking_url }}" target="_blank" style="margin-left: 5px">
                            Tracking
                          </a>
                        }
                      </td>
                      <td>
                        <button (click)="deleteDN(dn.id)">
                          <fa-icon [icon]="['far', 'trash']" />
                        </button>
                      </td>
                    </tr>
                  }
                </table>
              </section>
            </div>
            @if (importShipmentForm) {
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title flex flex-row gap-1">
                  <span class="flex-fill"> externe Sendungen hochladen </span>
                </h3>

                <p>
                  gültige Felder: <br />
                  - ticket_id (z.B: MI-20-044100)<br />
                  - carrier (z.B. UPS, DHL)<br />
                  - sendungsnummer (z.B. 1Z6932186861573064 )<br />
                  - versandatum (z.B. 14.08.20)<br />
                  - empfangsplz (z.B. 24251)
                  <br />
                  <br /><br />

                  Upload im <b>csv</b>-Format
                </p>

                <form [formGroup]="shippingImportform" (ngSubmit)="onShippingFileSubmit()">
                  <input type="file" name="importfile" (change)="onShippingFileChange($event)" />
                  <button type="submit">Upload</button>
                </form>

                @if (shippingImportStatus === "running") {
                  <div>
                    <h3>Import läuft, bitte warten!</h3>
                  </div>
                }

                @if (shippingImportStatus === "done") {
                  <div class="card-body">
                    <h3>Abgeschlossen!</h3>
                    <p>Anzahl Fehler: {{ shippingImporterrorIds.length }}</p>
                    <p>Fehlerhafte ids: {{ shippingImporterrorIds | json }}</p>
                    <p>log: {{ shippingImporterrorLog | json }}</p>
                  </div>
                }

                @if (shippingImportStatus === "error") {
                  <div class="card-body">
                    <h3>Fehler!</h3>
                  </div>
                }

                <button class="bm-btn" (click)="importShipmentForm = false">Schließen</button>
              </section>
            } @else {
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title flex flex-row gap-1">
                  <span class="flex-fill"> externe Sendungen </span>
                  <button class="bm-btn" (click)="importShipmentForm = true">
                    <fa-icon [icon]="['far', 'plus']" />
                    Neuen Import starten
                  </button>
                </h3>
                <table class="bm-table bm-table-sm">
                  @for (shipment of ticket.ticket_shipments; track shipment) {
                    <tr>
                      <td>
                        @if (!shipment.api_provider) {
                          <fa-icon [icon]="['far', 'question']" />
                        }
                        @if (shipment.api_provider) {
                          @switch (shipment.last_status) {
                            @case ("unknown") {
                              <fa-icon [icon]="['far', 'question']" />
                            }
                            @case ("delivered") {
                              <fa-icon [icon]="['far', 'check']" />
                            }
                            @case ("return_to_sender") {
                              <fa-icon [icon]="['far', 'undo']" />
                            }
                          }
                        }
                        {{ shipment.carrier }}: {{ shipment.carrier_tracking_no }}
                      </td>
                      <td>
                        {{ shipment.last_update | date: "dd.MM.yyyy HH:mm" }}
                      </td>
                    </tr>
                  }
                </table>
              </section>
            }
          </div>
        }
        @if (selectedTab === "billing") {
          <div class="grid grid-cols-2 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">An Kunden</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoiceCustomer = !editInvoiceCustomer">
                  <b>Rechnungsnummer</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoiceCustomer) {
                    {{ operation.invoice }}
                  } @else {
                    <hawk-shared-edit-input
                      [textValue]="operation.invoice"
                      (saveClicked)="saveInvoiceCustomer($event)"
                      (cancelClicked)="editInvoiceCustomer = false"
                    />
                  }
                </dd>

                <dt (click)="editInvoiceAmount = !editInvoiceAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoiceAmount) {
                    {{ operation.invoice_amount }}
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoiceAmount($event)"
                      (cancelClicked)="editInvoiceAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">Von Partner</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePartner = !editInvoicePartner">
                  <b>Rechnungsnummer</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePartner) {
                    {{ operation.invoice_partner }}
                  } @else {
                    <hawk-shared-edit-input
                      [textValue]="operation.invoice_partner"
                      (saveClicked)="saveInvoicePartner($event)"
                      (cancelClicked)="editInvoicePartner = false"
                    />
                  }
                </dd>

                <dt (click)="editInvoicePartnerAmount = !editInvoicePartnerAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePartnerAmount) {
                    {{ operation.invoice_partner_amount }}
                    @if (operation.invoice_partner_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_partner_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePartnerAmount($event)"
                      (cancelClicked)="editInvoicePartnerAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">PO / Bestellung</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePOAmount = !editInvoicePOAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePOAmount) {
                    {{ operation.invoice_po_order_amount }}
                    @if (operation.invoice_po_order_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_po_order_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePOAmount($event)"
                      (cancelClicked)="editInvoicePOAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>

            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">POX</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePOXAmount = !editInvoicePOXAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePOXAmount) {
                    {{ operation.invoice_pox_order_amount }}
                    @if (operation.invoice_pox_order_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_pox_order_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePOXAmount($event)"
                      (cancelClicked)="editInvoicePOXAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">PO15</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePO15Amount = !editInvoicePO15Amount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePO15Amount) {
                    {{ operation.invoice_po15_order_amount }}
                    @if (operation.invoice_po15_order_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_po15_order_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePO15Amount($event)"
                      (cancelClicked)="editInvoicePO15Amount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
          </div>
        }
        @if (selectedTab === "files") {
          <div class="grid grid-cols-2 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Hinterlegte Dateien</h3>
              <div class="flex flex-col gap-1">
                @for (file of files; track $index; let i = $index) {
                  <div class="flex flex-row items-center gap-1">
                    <a href="{{ file.path }}" target="_blank" class="bm-link bm-link-hover">
                      {{ file.filename }}
                    </a>
                    <button
                      type="button"
                      class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost text-error bm-tooltip"
                      data-tip="Löschen"
                      (click)="deleteFile(file.filename)"
                    >
                      <fa-icon [icon]="['far', 'trash']" />
                    </button>
                    <button
                      type="button"
                      class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-tooltip"
                      data-tip="Umbenennen"
                      (click)="editFileName[i] = true"
                    >
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </div>
                  @if (editFileName[i]) {
                    <hawk-shared-edit-input
                      [textValue]="file.filename"
                      (saveClicked)="updateFilename(file.filename, $event, i)"
                      (cancelClicked)="editFileName[i] = false"
                    />
                  }
                }
                <a
                  href="/r/api/v1/operations/{{ operation.id }}/report_{{ operation.id }}_{{ ticket.id }}.pdf"
                  target="_blank"
                  class="bm-link bm-link-hover"
                >
                  Servicebericht Einsatz (pdf)
                </a>
                <a
                  href="/r/api/v1/tickets/{{ ticket.id }}/report_{{ ticket.id }}.pdf"
                  target="_blank"
                  class="bm-link bm-link-hover"
                >
                  Servicebericht Ticket (pdf)
                </a>
                <a
                  href="/r/api/v1/operations/{{ operation.id }}/preview_report"
                  target="_blank"
                  class="bm-link bm-link-hover"
                >
                  Servicebericht 2026 (html)
                </a>
                <a [href]="reportPdfUrl()" target="_blank" class="bm-link bm-link-hover"> Servicebericht 2026 (pdf) </a>
              </div>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Neue Datei hochladen</h3>
              <div class="flex flex-row gap-1 items-center">
                <span class="bm-input"> Dateiauswahl </span>
                <hawk-shared-file-input (saveClicked)="saveUploadedFile($event)" [multiUpload]="true" />
              </div>
            </section>
          </div>
        }
        @if (selectedTab === "extras") {
          <div class="grid grid-cols-2 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Workflow Schritte ändern</h3>
              <hawk-workflow-upload-applet [ticketId]="ticket.id" [operationId]="operation.id" />
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Berichte neu erzeugen</h3>
              <table class="base">
                <tr>
                  <th>Einsatzbericht</th>
                  <td>
                    <a href="/r/api/v1/operations/{{ operation.id }}/regenerate_report.pdf">neu erzeugen</a>
                  </td>
                </tr>
                <tr>
                  <th>Servicebericht 2026</th>
                  <td>
                    <a [href]="reportPdfUrl(true)" target="_blank">neu erzeugen</a>
                  </td>
                </tr>
              </table>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">hinterlegte Workflow Schritte</h3>
              <hawk-workflow-upload-applet [projectId]="ticket.project_id" />
            </section>
          </div>
        }
        @if (selectedTab === "mt_bonus") {
          <div class="grid grid-cols-3 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title">Ablehnung hinterlegen</h3>
              <div>hierdurch wird der Status auf Rejected geändert und der entsprechende Code an MT übertragen.</div>
              <fieldset class="bm-fieldset p-0">
                <label class="bm-select w-full">
                  <span class="bm-label w-32">Grund</span>
                  <select class="w-full" [(ngModel)]="mtRejectionSelectedReason" [disabled]="!canReject">
                    @for (typ of mtRejectionReasons; track $index) {
                      <option [ngValue]="typ.key">
                        {{ typ.title }}
                      </option>
                    }
                  </select>
                </label>
                <label class="bm-input w-full">
                  <span class="bm-label w-32">TSRC</span>
                  <input class="w-full" type="text" [disabled]="true" [value]="mtRejectionSelectedReason" />
                </label>
                @if (mtRejectionSelectedReason) {
                  <label class="bm-input w-full">
                    <span class="bm-label w-32">Freitext</span>
                    <input
                      class="w-full"
                      type="text"
                      maxlength="999"
                      [(ngModel)]="mtRejectionText"
                      placeholder="Begründung eingeben"
                      style="width: 100%"
                      [disabled]="!canReject"
                    />
                  </label>
                  <div role="alert" class="bm-alert bm-alert-error bm-alert-soft">
                    <span>Aktion nicht umkehrbar!</span>
                  </div>
                  <button class="bm-btn bm-btn-primary" (click)="sendRejection()" [disabled]="!canReject">
                    Ticket ablehnen
                  </button>
                }
              </fieldset>
            </section>

            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300 row-span-2 col-span-2">
              <h3 class="bm-card-title flex flex-row gap-1">Techniker Werte überschrieben:</h3>
              <table class="bm-table bm-table-xs">
                <tr>
                  <th>id</th>
                  <th>sn</th>
                  <th>sn löschen?</th>
                  <th>sst_id</th>
                  <th>key</th>
                  <th>value</th>
                  <th></th>
                </tr>
                @for (override of mtOverrides; track override.id) {
                  <tr>
                    <td>{{ override.id }}</td>
                    <td>{{ override.sn }}</td>
                    <td>{{ override.delete_item }}</td>
                    <td>{{ override.sst_id }}</td>
                    <td>{{ override.mt_key }}</td>
                    <td>{{ override.mt_value }}</td>
                    <td>
                      <button
                        class="bm-btn bm-btn-square bm-btn-ghost bm-tooltip"
                        (click)="deleteOverride(override)"
                        data-tip="Eintrag löschen"
                      >
                        <fa-icon [icon]="['fas', 'trash']" class="text-error" />
                      </button>
                    </td>
                  </tr>
                }
              </table>

              <fieldset class="bm-fieldset">
                <legend class="bm-fieldset-legend">Neuen Wert überschreiben</legend>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">sn</label>
                  <input
                    class="w-full"
                    type="text"
                    maxlength="30"
                    [(ngModel)]="mtOverridesSn"
                    placeholder="Seriennummer"
                  />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">sst_id</label>
                  <input class="w-full" type="text" maxlength="30" [(ngModel)]="mtOverridesSST" placeholder="SST ID" />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">key</label>
                  <input class="w-full" type="text" maxlength="50" [(ngModel)]="mtOverridesKey" placeholder="mt_key" />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">value</label>
                  <input
                    class="w-full"
                    type="text"
                    maxlength="255"
                    [(ngModel)]="mtOverridesValue"
                    placeholder="mt_value"
                  />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">SN löschen</label>
                  <input class="w-full" type="checkbox" [(ngModel)]="mtOverridesDelete" />
                </label>
                <button class="bm-btn bm-btn-primary" (click)="addOverride()">Übeschreiben hinzufügen</button>
              </fieldset>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">XML Log</h3>
              <p>folgende Dateien wurden an MT übertragen</p>
              @for (response of ticket.mt_responses; track $index) {
                <pre>{{ response | json }}</pre>
              }
            </section>
          </div>
        }
        @if (selectedTab === "mt_devices") {
          <!-- MT Geräte Tab - Geräteliste mit Service-Aufträgen -->
          @if (mtInstalledItemKeys.length > 0) {
            @for (serialnumber of mtInstalledItemKeys; track serialnumber) {
              <div class="collapse collapse-arrow bg-base-200 mb-2">
                <input type="checkbox" />
                <div class="collapse-title font-medium">
                  <div class="flex justify-between items-center">
                    <span>
                      <span class="badge badge-sm badge-neutral mr-2"
                        >#{{ ticket.mt_items[serialnumber].item_sequence_number }}</span
                      >
                      <span class="font-bold">{{ serialnumber }}</span>
                      <span class="ml-2 text-sm opacity-70">{{ ticket.mt_items[serialnumber].item_type }}</span>
                    </span>
                    <span class="text-sm">
                      @if (ticket.mt_items[serialnumber].item_location) {
                        <span class="badge badge-outline badge-sm">{{
                          ticket.mt_items[serialnumber].item_location
                        }}</span>
                      }
                      @if (ticket.mt_items[serialnumber].contract_coverage) {
                        <span
                          class="badge badge-sm ml-1"
                          [ngClass]="{
                            'badge-success':
                              ticket.mt_items[serialnumber].contract_coverage !== 'Kein Vertrag vorhanden',
                            'badge-warning':
                              ticket.mt_items[serialnumber].contract_coverage === 'Kein Vertrag vorhanden',
                          }"
                        >
                          {{ ticket.mt_items[serialnumber].contract_coverage }}
                        </span>
                      }
                    </span>
                  </div>
                </div>
                <div class="collapse-content">
                  <!-- Gerät-Details -->
                  <div class="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm mb-4">
                    @if (ticket.mt_items[serialnumber].item_ip_address) {
                      <div>
                        <span class="font-semibold">IP:</span> {{ ticket.mt_items[serialnumber].item_ip_address }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].manufacturer) {
                      <div>
                        <span class="font-semibold">Hersteller:</span> {{ ticket.mt_items[serialnumber].manufacturer }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].legal_for_trade_date) {
                      <div>
                        <span class="font-semibold">Eichdatum:</span>
                        {{ ticket.mt_items[serialnumber].legal_for_trade_date }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].legal_for_trade_status) {
                      <div>
                        <span class="font-semibold">Eichstatus:</span>
                        {{ ticket.mt_items[serialnumber].legal_for_trade_status }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].component_id) {
                      <div>
                        <span class="font-semibold">Komponenten-ID:</span>
                        {{ ticket.mt_items[serialnumber].component_id }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].component_status) {
                      <div>
                        <span class="font-semibold">Komponentenstatus:</span>
                        {{ ticket.mt_items[serialnumber].component_status }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].ref_product_number) {
                      <div>
                        <span class="font-semibold">Produktnr.:</span>
                        {{ ticket.mt_items[serialnumber].ref_product_number }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].ref_product_material) {
                      <div>
                        <span class="font-semibold">Produkt:</span>
                        {{ ticket.mt_items[serialnumber].ref_product_material }}
                      </div>
                    }
                    @if (ticket.mt_items[serialnumber].checklist_id_mt) {
                      <div>
                        <span class="font-semibold">Checkliste:</span>
                        {{ ticket.mt_items[serialnumber].checklist_id_mt }}
                      </div>
                    }
                  </div>

                  <!-- Service-Aufträge (SSTs) -->
                  @if (
                    ticket.mt_items[serialnumber].service_orders &&
                    ticket.mt_items[serialnumber].service_orders.length > 0
                  ) {
                    <h4 class="font-semibold text-sm mb-2">Service-Aufträge (SSTs)</h4>
                    @for (sst of ticket.mt_items[serialnumber].service_orders; track sst.service_type_id) {
                      <div class="card card-compact bg-base-100 mb-2">
                        <div class="card-body">
                          <div class="flex justify-between items-center">
                            <span>
                              <span class="badge badge-primary badge-sm">{{ sst.service_type_id }}</span>
                              <span class="ml-2">{{ sst.service_type_text }}</span>
                            </span>
                            <span
                              class="badge"
                              [ngClass]="{ 'badge-success': sst.completed, 'badge-warning': !sst.completed }"
                            >
                              {{ sst.completed ? "Erledigt" : sst.device_service_status }}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  } @else {
                    <div class="text-sm opacity-60 italic">Keine Service-Aufträge für dieses Gerät</div>
                  }
                </div>
              </div>
            }
          } @else {
            <div class="text-center py-8 opacity-60">Keine MT-Geräte vorhanden</div>
          }
        }
      </div>
    </div>
  </section>
</div>

@if (cancelDialog) {
  <hawk-cancel-installation-dialog
    [ticketId]="ticket.id"
    [articleHandlingId]="cancelDialog.handlingId"
    [articleDescription]="cancelDialog.description"
    [articleSn]="cancelDialog.sn"
    (cancelled)="onInstallationCancelled($event)"
    (closed)="closeCancelDialog()" />
}
